var _style, _path, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _path2, _rect, _circle, _circle2, _polygon15, _path3, _path4, _ellipse, _polygon16, _path5, _polygon17, _polygon18, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g, _path17, _path18, _path19, _g2, _g3, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCartoonTy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b52d7e2d-d80f-4111-b6ed-d15502ee1edd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 743.2 704.7",
    style: {
      enableBackground: "new 0 0 743.2 704.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#7AAFD1;}\r\n\t.st1{fill:#E6E6E6;}\r\n\t.st2{opacity:0.1;enable-background:new    ;}\r\n\t.st3{fill:#001C55;}\r\n\t.st4{fill:#F2F2F2;}\r\n\t.st5{fill:#3F3D56;}\r\n\t.st6{opacity:0.1;fill:#00194D;enable-background:new    ;}\r\n\t.st7{fill:#FFB8B8;}\r\n\t.st8{fill:#2F2E41;}\r\n\t.st9{fill:#0E6BA8;}\r\n\t.st10{fill:#FFD07E;}\r\n\t.st11{fill:#DB8E05;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M422,95.9c-21.1-4.5-71.6-14.5-155-52c-56.3-25.3-60.8-32.8-90-38c-30.8-5.4-63.9-3.8-76-3 c-15.5,1.1-24.3,1.7-36,5c-8.1,2.3-54.5,15.6-62,43c-4.7,17.2,8.7,29.7,47,81c38.1,50.9,56.7,77.1,65,100c8.1,22.5,13.7,57.6-3,109 c67.5,31.3,117.2,57.7,150,76c33.3,18.6,38.9,24.1,43,28c36.8,35.2,39.2,77.3,82,100c4.7,2.5,8.7,4.1,11,5c16.7,6.7,40,13.1,67,11 c80.2-6.1,135.9-82.2,192-159c24.1-33,44.2-65.7,61-97c2.6-7.7,6.2-20.3,8-36c6.6-57.1-16.2-103.7-32-135 c-18.9-37.3-28.1-56.2-40-62c-47.5-23.1-103.7,39-207,28C436.1,98.7,427.4,97,422,95.9z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "548.3,415 548.3,600 579.3,650.4 581.6,654.3 703.7,654.3 706.2,415 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "548.3,415 548.3,600 579.3,650.4 581.2,415 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "253.6,410.1 253.6,595.1 222.6,645.5 220.3,649.3 98.2,649.3 95.7,410.1 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "253.6,410.1 253.6,595.1 222.6,645.5 220.7,410.1 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "743.2,406.4 743.2,417.5 79.7,417.5 79.7,401.5 141.3,369.4 688.9,369.4 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "743.2,406.4 743.2,417.5 79.7,417.5 79.7,401.5 "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "174.6,461.9 145,461.9 132.7,453.2 188.2,453.2 "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "174.6,497.6 145,497.6 132.7,489 188.2,489 "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "174.6,548.2 145,548.2 132.7,539.6 188.2,539.6 "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "174.6,598.8 145,598.8 132.7,590.1 188.2,590.1 "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "627.3,466.8 656.9,466.8 669.2,458.2 613.7,458.2 "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "627.3,502.6 656.9,502.6 669.2,493.9 613.7,493.9 "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "627.3,553.1 656.9,553.1 669.2,544.5 613.7,544.5 "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "627.3,603.7 656.9,603.7 669.2,595.1 613.7,595.1 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M647.4,155.5H398.2c-5.2,0-9.4,4.2-9.4,9.4c0,0,0,0,0,0v167.9c0,5.2,4.2,9.4,9.4,9.4c0,0,0,0,0,0h94.6 l-3.5,22.6c0,0-20.3,10.8-6,11.1s81.3,0,81.3,0s13,0-7.6-11.4l-3.3-22.3h93.7c5.2,0,9.4-4.2,9.4-9.4c0,0,0,0,0,0V164.9 C656.8,159.7,652.6,155.5,647.4,155.5C647.4,155.5,647.4,155.5,647.4,155.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 397.8,
    y: 165.4,
    className: "st4",
    width: 250,
    height: 139.9
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 522.8,
    cy: 161,
    r: 1.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 522.8,
    cy: 329.3,
    r: 6
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "513.5,393 513.5,396.1 343.2,396.1 343.2,393.6 343.4,393 347.6,381.6 510,381.6 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M579,389.9c-0.3,1.3-1.5,2.7-4.1,4c-9.5,4.7-28.8-1.3-28.8-1.3s-14.9-2.5-14.9-9.2c0.4-0.3,0.9-0.5,1.3-0.8 c4-2.1,17.2-7.3,40.7,0.2c1.7,0.5,3.3,1.6,4.5,2.9C578.7,386.9,579.2,388.4,579,389.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M579,389.9c-11.6,4.5-22,4.8-32.6-2.6c-4-3-8.9-4.6-13.9-4.6c4-2.1,17.2-7.3,40.7,0.2c1.7,0.5,3.3,1.6,4.5,2.9 C578.7,386.9,579.2,388.4,579,389.9z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 564.4,
    cy: 386,
    rx: 4.1,
    ry: 1.3
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "513.5,393 513.5,396.1 343.2,396.1 343.2,393.6 343.4,393 "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M114.1,109.9c0,0,3.5,28.8-9.2,31.1s11.5,41.4,11.5,41.4l57.6,6.9l-13.8-46c0,0-9.2-3.5-3.5-26.5 S114.1,109.9,114.1,109.9z"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "79,604.3 83.6,667.6 107.8,667.6 100.9,604.3 "
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "256.3,484.6 259.8,537.6 286.2,526 275.9,482.3 "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M61.8,362.6c0,0,1.2,66.8,8.1,88.6s5.8,23,4.6,26.5s-2.3,1.2-2.3,6.9s-2.3,96.7,0,104.8s-6.9,21.9,0,23 s39.1,0,40.3-6.9c1.2-6.9-9.2-9.2-4.6-13.8c4.6-4.6,11.5-99,11.5-99l16.1-65.6l29.9-34.5h63.3l19.6,76c0,0-8.1,21.9-2.3,21.9 s40.3,6.9,40.3-18.4s-11.5-100.1-13.8-102.5s1.2-10.4-2.3-13.8c-3.5-3.5-43.7-27.6-58.7-32.2s-36-10.1-36-10.1L61.8,362.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M286.2,516.8c0,0-17.3-5.8-25.3,11.5c-8.1,17.3-4.6,21.9-4.6,21.9s26.5,9.2,31.1,4.6c2-2,8.4-2.7,14.9-2.8 c10-0.2,12.6-14.3,3.2-17.6c-0.3-0.1-0.6-0.2-0.9-0.3C295.4,531.8,286.2,516.8,286.2,516.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M136.6,35.7c16.8-0.1,29.6,21.9,32.3,38.8c4.2,26.4-13.4,57.7-31.5,57.9c-17.5,0.2-35.3-29.1-32.8-54.7 C106.4,59.4,119.1,35.8,136.6,35.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M95.1,155.4c0,0,56.4,11.5,70.2-6.9s19.6,51.8,19.6,51.8l6.9,73.7l-10.4,40.3c0,0-54.1,43.7-71.4,47.2 s-43.7,5.8-43.7,5.8s8.1-127.8,8.1-130.1S95.1,155.4,95.1,155.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M112.3,133.8c0,0-12.5-7.2-16-0.3s-35.7,24.2-39.1,24.2s6.9,95.5,2.3,107.1S33,360.3,45.6,367.2 s3.5-6.9,16.1,10.4s74.8,17.3,78.3,10.4s-27.6-58.7-21.9-107.1s15-115.1,6.9-124.3S112.3,133.8,112.3,133.8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M153.9,141.6l1.6-5.5c0,0,47.9,15.9,50.2,26.2s1.2,82.9-6.9,88.6s-19.6,15-11.5,28.8s17.3,28.8,24.2,29.9 s19.6,9.2,16.1,17.3s-44.9-6.9-44.9-6.9s-27.6-20.7-26.5-53S153.9,141.6,153.9,141.6z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M194.1,277.4l-27.6,51.8c0,0-40.3,41.4-17.3,46s35.7-38,35.7-38l29.9-42.6L194.1,277.4z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M194.1,157.7l10.7,2.8c0,0,25,63.9,19.2,107.7s-9.2,34.5-9.2,34.5s-9.2-20.7-29.9-16.1L194.1,157.7z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M80.6,659.3c-2.8,3.8-2.2,9.2-4.7,13.2c-2.1,3.5-6.1,5.3-8.8,8.3c-0.9,1-1.6,2.1-2.3,3.3 c-2.5,4.1-4.5,9.5-2,13.6c2,3.4,6.1,4.7,9.9,5.6c4.8,1.1,9.7,2,14.6,1.2s9.5-3.8,11.3-8.4c0.3-1.2,0.7-2.3,1.2-3.4 c2.6-5.2,10.8-5.2,13.5-10.3c1.9-3.6,0.2-7.9-1.6-11.6l-5.3-11.2c-1.7-3.7-8.8-1.6-12.5-2.5C89.1,655.8,84.1,654.5,80.6,659.3z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M42.2,300.4l48.3,74.8c0,0,29.9,38,39.1,20.7s-32.2-46-32.2-46l-31.1-57.6L42.2,300.4z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M66.4,160l-9.2-2.3c0,0-18.4,5.8-23,29.9s-1.2,120.9,4.6,122s28.4-16.8,32.1-13s-7.9-15.8-4.4-26.1 S66.4,160,66.4,160z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f3c2397c-d780-4cc6-97d8-1503d8277a2c"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ad41612f-86f7-46b2-a964-3a5da7bcf3cf",
    x: 469.4,
    y: 211.4,
    className: "st9",
    width: 29.8,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "b9a0b375-cc2a-4c59-8850-661af54e4f62",
    x: 591.7,
    y: 211.4,
    className: "st9",
    width: 10.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "e174c2ab-9bc5-41ec-b37c-b06fbf8a9878",
    x: 612.7,
    y: 211.4,
    className: "st9",
    width: 10.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "ba2479ac-4c7d-43b4-a028-73b1e20e4002",
    x: 509.6,
    y: 211.4,
    className: "st9",
    width: 71.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "ac60ef86-00f2-480b-8171-28b6fdfc1958",
    x: 431.9,
    y: 257.6,
    className: "st9",
    width: 29.8,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "b3d8298d-cd65-487a-8b19-4cee946356e7",
    x: 554.3,
    y: 257.6,
    className: "st9",
    width: 10.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "ed27f15f-f0c4-4569-8330-a6688f8e356c",
    x: 575.2,
    y: 257.6,
    className: "st9",
    width: 10.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "f685c005-adaf-4d60-acda-005b037d82a6",
    x: 472.2,
    y: 257.6,
    className: "st9",
    width: 71.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "eca7c7fc-83f8-48ca-a588-6606db47af3f",
    x: 554.8,
    y: 227.3,
    className: "st9",
    width: 29.8,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "a71b5b2f-f8b9-481d-a301-5e3357e5fe42",
    x: 595,
    y: 227.3,
    className: "st9",
    width: 29.8,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "abb3a25a-f854-41fc-8391-e6ad9fbe2417",
    x: 431.9,
    y: 227.3,
    className: "st9",
    width: 10.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "add2b425-b775-4eb5-9c25-8c4c14f957c9",
    x: 452.9,
    y: 227.3,
    className: "st9",
    width: 10.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "b7159612-3b84-4b0b-a885-612eaab04c06",
    x: 473.8,
    y: 227.3,
    className: "st9",
    width: 71.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "edfc7301-4de5-47dc-80e2-1ae2da982d6d",
    x: 493.1,
    y: 242.8,
    className: "st9",
    width: 29.8,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "e1009f91-6275-4375-80fa-0d778e331fdc",
    x: 452.9,
    y: 242.8,
    className: "st9",
    width: 29.8,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "a060fb9f-1f1a-4862-9a69-16dd49199e18",
    x: 431.9,
    y: 242.8,
    className: "st9",
    width: 10.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "b6754d5f-104f-449c-b9a9-cf9ac82bf5fe",
    x: 614.3,
    y: 242.8,
    className: "st9",
    width: 10.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "e6ed1ccd-2cfd-450f-a339-07df3a1ee6bb",
    x: 532.8,
    y: 242.8,
    className: "st9",
    width: 71.1,
    height: 7.2
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M163.1,22.5c-2-1.8-8.1,1.6-18.4,7.3c-6.4,3.6-6.4,4.1-8.8,4.6c-5.4,1.2-8.9-0.9-14.2,1.7 c-1.8,0.9-3.1,1.8-3.8,2.4c-2.3,2-3.4,4.7-8.8,11.4c-6,7.4-7.3,8.4-8.4,11.3c-0.9,2.1-2.3,6.4-1.4,14.4c1.1,9,4.5,16.7,6.3,20.4 c-0.5-3.8-0.8-9.6,0.9-16.2c0.8-3,1.8-5.5,2.9-7.6c0,0,0-0.1,0-0.2c1.2-6.3,2.8-11.4,3.4-13.3c1.6-4.5,4.3-11.9,10.1-13.9 c5.5-1.9,8.8,2.9,18.4,3.4c5.7,0.3,10.5-1,13.8-2.3c3.2,3.5,9.1,11,12,22.2c2.9,10.9,1.5,20.1,0.6,24.7c8.4-12.2,9.5-21.6,8.9-28.1 c-0.5-5.3-2-6.2-3.1-14.8c-1.7-13,0.3-21-2.3-21.9c-2.8-0.9-7.6,7.7-9.2,6.9C160.4,34.2,165.7,24.8,163.1,22.5z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M269,82.9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M211,70.9"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,640.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1568.7,5678.7c-1.2-0.1-4.9-0.4-8.3-0.6c-16.2-1.3-35.3-4.7-66.7-12c-48.8-11.2-64.2-13.6-88.8-13.6 c-22,0-30.8,1.4-67.8,10.8c-9.8,2.5-20.1,5-22.6,5.5c-12.1,2.5-43.2,7.2-57.4,8.6c-11.2,1.1-37.3,1.1-46.7,0 c-15.7-1.9-29.4-4.7-58.4-11.9c-10.3-2.5-23.6-5.7-29.6-7s-11.1-2.5-11.2-2.7c-0.1-0.1-0.3-6.8-0.3-14.9 c-0.1-22.8,0-23.4,12.4-39.6c5-6.5,8.1-11.8,9.5-16c0.4-1.2,1.4-5.2,2.1-8.6c5.8-27,14-54.8,24-80.8c4.9-12.8,9.2-19.6,17.2-27.1 c12.6-11.9,33.6-21.3,55.4-24.9c9.9-1.6,16.8-2,28.9-1.7c28.8,0.7,46.4,5.9,63.9,19c4.7,3.5,14,12.6,18.2,17.8 c10.2,12.6,20,29.2,28.6,48.7c5,11.4,6.1,14.8,10.4,32.8c3.2,13.5,5.5,21,8,26s3.3,6,6.1,7.3c2.5,1.1,2.7,1.1,10.9,0.9 c11.7-0.5,11.5-0.4,15.1-4c2.5-2.5,3.5-4,5.8-8.7c2.9-6.1,4.2-9.8,7.7-23.2c7.7-29.3,18.7-54,32-72.2c4.5-6.1,16.4-18,22-21.9 c32.4-22.9,77.9-28.3,114.4-13.8c28.2,11.3,48,32.6,58.3,63.1c3.2,9.5,5.2,17.2,9.7,37.3c6.3,28.5,9.1,38.3,12.7,45.7 c2.9,5.8,4.9,8.3,11,13.1c3.6,2.9,4.5,6.9,3.7,17.8c-0.3,4.4-0.3,8.1,0,11.9c0.8,9.1-0.5,13.2-5,15.6c-1.5,0.8-4.7,1.7-8.9,2.7 c-6.9,1.4-12.4,2.9-27.6,7.8c-12.5,4-19.6,5.6-36.8,8.6c-22.1,3.7-27.6,4.4-39.6,4.6C1575.4,5678.8,1569.8,5678.8,1568.7,5678.7z  M1284.2,5658.7c10.4-0.9,22.8-3.6,35-7.5c26-8.4,40.7-19.3,46.8-34.8c2.3-5.8,3.1-10.8,3.1-19.1c0-9.8-1.7-19.7-5.6-33.1 c-3.4-11.5-11.5-32.6-16.6-43.3c-14.3-29.9-36.5-49.3-65-56.8c-19.1-5-42-4.3-63.8,1.7c-20.7,5.8-36.3,20.6-45.3,42.9 c-4,10.1-10,32.5-13.1,49.5c-4.4,23.9-5.4,49.2-2.4,60.3c5.2,19.4,20.7,30.1,51.6,35.6c5.9,1.1,24.1,3.4,32.4,4.2 C1255.9,5659.6,1271.6,5659.8,1284.2,5658.7z M1570,5658.4c9.9-0.8,20.9-2.2,30.5-3.6c27-4.2,42.5-11.5,50.7-23.9 c5.3-8.1,6.7-13.4,7-28.6c0.5-22.6-2.9-45.4-11.2-75.7c-3.2-11.7-4.7-16-8.2-23.2c-4.7-9.8-9.6-16.6-16.5-23 c-8.1-7.6-17.2-12.4-29.3-15.4c-36-9-68.5-3.9-93.5,14.8c-15.6,11.6-27.5,28.2-37.1,52c-12.7,31.3-17.9,51.5-17.3,67.6 c0.1,3.4,0.6,7.9,1,9.9c4.2,20.1,21.7,34.2,54,43.4c15,4.3,23.7,5.8,39.9,6.7C1545,5659.6,1561.9,5659.1,1570,5658.4z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M158.5,107.5c-0.3,1.6-4.7-0.8-4.7-0.8l0,0c-3.6-2.1-7.4-4-8.7-4.7c-0.1-0.1-0.3-0.1-0.4-0.2 c-0.1,0-0.1,0-0.1,0c-1.4-0.5-3,0.2-3.5,1.6c-0.5,1.4,0.2,3,1.6,3.5c0.2,0.1,0.4,0.1,0.6,0.1c2.2,0.5,9.7,2.3,12.8,2.5 C160,110.1,158.8,105.7,158.5,107.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M122.5,107.5c-0.3-1.8-1.6,2.6,2.5,2c3.2-0.2,10.7-1.9,12.8-2.5c0.2,0,0.4-0.1,0.6-0.1 c1.4-0.5,2.1-2.1,1.6-3.5c-0.5-1.4-2.1-2.2-3.5-1.6c0,0,0,0-0.1,0c-0.1,0.1-0.3,0.1-0.4,0.2c-1.3,0.7-5.1,2.6-8.7,4.7l0,0 C127.3,106.7,122.8,109.1,122.5,107.5z"
  }))))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M141.3,118.7c4,0.2,4.9,4.6,8.1,4.6c9.7,0,15.5-19.9,16.7-19.4c1.3,0.6-3,29.9-20.1,34.4c-3.9,1-7.1,0.4-9.2,0 c-20.8-4.1-30.3-33.5-28.7-34.5c1.5-1,15.5,22.3,25.1,19.1C136,121.9,137.5,118.5,141.3,118.7z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M908,72.9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartoonTy);
export default __webpack_public_path__ + "static/media/cartoonTy.5fbb6cd9125cd4a561b4a5384ed743c7.svg";
export { ForwardRef as ReactComponent };